import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { clearFirstLoadCifCups } from "../../utils/components/cupsCifSelector/cupsCifSelector.util";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";

const PathnameChangeComponent = () => {
  const { pathname } = useLocation();
  const { storageCifCupsState, cifCupsState } =
    useContext(TotalEnergiesContext);
  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    setIsFirstLoad(true);
  }, [pathname]);

  useEffect(() => {
    if (isFirstLoad && cifCupsState) {
      !cifCupsState.isLoading &&
        storageCifCupsState(clearFirstLoadCifCups(cifCupsState.listCupsCifRaw));
      setIsFirstLoad(false);

      return () =>
        !cifCupsState.isLoading
          ? storageCifCupsState(
              clearFirstLoadCifCups(cifCupsState.listCupsCifRaw)
            )
          : void 0;
    }
  }, [cifCupsState, isFirstLoad, storageCifCupsState]);

  return <></>;
};

export default PathnameChangeComponent;
